module.exports = __webpack_public_path__ + "5ab6eec13bcf0b7916c41f52dace28e5.MP3";